import React from 'react';

/** Stitch-style dashed “pitch” rule between major sections */
export function GuidePitchDivider({ className = '' }) {
  return <hr className={`pitch-divider border-0 my-12 md:my-16 ${className}`} aria-hidden="true" />;
}

export default GuidePitchDivider;
